module.exports = __webpack_public_path__ + "static/media/blind.2bf01a99.svg";